import React, { useEffect, useState } from 'react';
import {
  SearchCity,
  SearchProvince,
} from '@bvt-features/mainmap/place/component/MapAdvancedSearch';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import './ChangeArea.scss';
import { ImageBox } from '@bvt-shared/component/ImageBox';

/**
 * @version 1.0
 * @copyright PT Bhumi Varta Technology
 * @memberof griana
 * @author Imam <imam.rozali@bvarta.com>
 * @param {Object} props
 * @param {Function} props.setCity
 * @param {Object} props.city
 * @param {Function} props.setProvince
 * @param {Object} props.province
 * @param {Function} props.isAdvanced
 */

const IconCloseTemporary = () => {
  return (
    <svg
      className='close-advanced'
      height='12.263'
      viewBox='0 0 12.263 12.263'
      width='12.263'
    >
      <path
        d='M3.153,7.489V5.518H1.183a1.182,1.182,0,1,1,0-2.364h1.97V1.183a1.183,1.183,0,1,1,2.365,0V3.154H7.489a1.182,1.182,0,1,1,0,2.364H5.518V7.489a1.183,1.183,0,1,1-2.365,0Z'
        data-name='Union 24'
        fill='currentColor'
        id='Union_24'
        transform='translate(6.132) rotate(45)'
      />
    </svg>
  );
};

export default function ChangeArea(props) {
  const {
    isAdvanced,
    city,
    setCity,
    setProvince,
    province,
    onSubmit,
    onDuplicate,
  } = props;
  const [step, setStep] = useState(0);
  const [name, setName] = useState('');

  const handleClear = () => {
    setName('');
  };

  const internalHandleDuplicate = () => {
    try {
      onDuplicate && onDuplicate({ name });
      return true;
    } catch (error) {
      return false;
    }
  };

  const renderChooseSelect = (
    <>
      <div className='bvt-changearea__card__header'>
        <div className='bvt-changearea__card__header__title'>Change Area</div>
        <button
          className='bvt-changearea__card__header__button'
          onClick={() => isAdvanced(false)}
        >
          <IconCloseTemporary />
        </button>
      </div>
      <div
        className='bvt-changearea__card__body'
        style={{ width: '22.5rem', gap: '1rem', alignItems: 'center' }}
      >
        <span className='bvt-changearea__card__body__title'>
          Change Project Area?
        </span>
        <span className='bvt-changearea__card__body__desc'>
          This will replace the current result with new area using the same
          parameter.
          <br /> Duplicate it to keep the existing result.
        </span>
      </div>
      <div className='bvt-changearea__card__footer'>
        <div
          className='bvt-changearea__card__footer__button__active'
          onClick={() => setStep(2)}
        >
          Change
        </div>
        <div
          className='bvt-changearea__card__footer__button__active'
          onClick={() => setStep(1)}
        >
          Duplicate
        </div>
      </div>
    </>
  );

  useEffect(() => {
    if(step === 1){
      props.loadingDuplicate === 'SUCCESS' && setStep(2);
    }
  }, [props.loadingDuplicate]);

  const renderSelectArea = (
    <>
      <div className='bvt-changearea__card__header'>
        <div className='bvt-changearea__card__header__title'>Change Area</div>
        <button
          className='bvt-changearea__card__header__button'
          onClick={() => isAdvanced(false)}
        >
          <IconCloseTemporary />
        </button>
      </div>
      <div className='bvt-changearea__card__body' style={{ width: '22.5rem' }}>
        <SearchProvince isProvince={setProvince} province={province} validation={true}/>
        <SearchCity
          data={city}
          idProvince={province?.id_provinsi}
          isCity={setCity}
          validation={true}
        />
      </div>
      <div className='bvt-changearea__card__footer'>
        <div
          className='bvt-changearea__card__footer__button__active'
          onClick={() => isAdvanced(false)}
        >
          Cancel
        </div>
        <div
          className={
            !isEmpty(province) && !isEmpty(city)
              ? 'bvt-changearea__card__footer__button__active filled'
              : 'bvt-changearea__card__footer__button'
          }
          onClick={() =>
            !isEmpty(province) && !isEmpty(city)
              ? onSubmit() & isAdvanced(false)
              : void 0
          }
        >
          Apply
        </div>
      </div>
    </>
  );

  const renderDuplicateProject = (
    <>
      <div className='bvt-changearea__card__header'>
        <div className='bvt-changearea__card__header__title'>
          Duplicate from your saved project
        </div>
        <button
          className='bvt-changearea__card__header__button'
          onClick={() => isAdvanced(false)}
        >
          <IconCloseTemporary />
        </button>
      </div>
      <div
        className='bvt-changearea__card__body-duplicate'
        style={{ width: '35.5rem', gap: '1rem' }}
      >
        <div
          className={`bvt-changearea__card__body-duplicate__input_group ${
            props.errorMessage ? 'error' : ''
          }`}
          // style={{ borderColor: props.value ? '#007e75' : '' }}
        >
          <input
            onChange={(e) => setName(e.target.value)}
            placeholder='New Area Project'
            type='text'
            value={name}
          />
          {name && (
            <span className='close-icon' onClick={() => handleClear()}>
              <ImageBox src='ic-close' />
            </span>
          )}
        </div>
        {props.errorMessage && (
          <div className='error-message'>{props.errorMessage}</div>
        )}
      </div>
      <div className='bvt-changearea__card__footer'>
        <div
          className='bvt-changearea__card__footer__button__active'
          onClick={() => isAdvanced(false)}
        >
          Cancel
        </div>
        <div
          className={
            !isEmpty(name)
              ? 'bvt-changearea__card__footer__button__active filled'
              : 'bvt-changearea__card__footer__button'
          }
          onClick={() =>
            !isEmpty(name)
              ? internalHandleDuplicate() //funtion for add name or duplicate name
              : void 0
          }
        >
          Duplicate
        </div>
      </div>
    </>
  );
  return (
    <div className='bvt-changearea'>
      <div className='bvt-changearea__card'>
        {step === 0 && renderChooseSelect}
        {step === 1 && renderDuplicateProject}
        {step === 2 && renderSelectArea}
      </div>
    </div>
  );
}

ChangeArea.propTypes = {
  city: PropTypes.object,
  isAdvanced: PropTypes.func,
  onSubmit: PropTypes.func,
  province: PropTypes.object,
  setCity: PropTypes.func,
  setProvince: PropTypes.func,
};
